import { getStoredSession } from "@/shared/auth/fetch/authStorage";
import { type Result, err, ok } from "neverthrow";

export const getAuthHeaders: () => Result<Record<string, string>, Error> =
  () => {
    const session = getStoredSession();
    if (!session) {
      return err(new Error("session is not stored yet"));
    }
    return ok({
      "access-token": session.tokens["access-token"],
      client: session.tokens.client,
      uid: session.tokens.uid,
    });
  };
